import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLLONGLEGGEDDOJI', label: 'Long-Legged Doji', lookback: 10 })
